import type { TOC } from '@ember/component/template-only';
import GeneralTablesCellsTdTwoLine from 'lumen/components/general/tables/cells/td-two-line';

type TwoLineData = {
  primary: string;
  secondary?: string;
};

interface SettingsActivityTdExpandableCellSignature {
  Args: {
    cellData: TwoLineData | string;
    row: { isHeader?: boolean };
  };
}

const isTwoLineData = (data: TwoLineData | string): data is TwoLineData => {
  return data !== null && typeof data === 'object' && 'primary' in data;
};

const TdExpandableCell = <template>
  {{#if (isTwoLineData @cellData)}}
    <GeneralTablesCellsTdTwoLine @cellData={{@cellData}} />
  {{else}}
    <div
      class="line-clamp-3
        {{if @row.isHeader 'text-200--bold' 'text-200--regular'}}"
      title={{@cellData}}
    >
      {{@cellData}}
    </div>
  {{/if}}
</template> satisfies TOC<SettingsActivityTdExpandableCellSignature>;

export default TdExpandableCell;
